// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3908":"a458ca9f","7383":"e6f4b673","7460":"e6f4b673"}[chunkId] + ".chunk.css";
};